"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IAnnotationCanvasStyle = void 0;
var utils_1 = require("../../../utils");
var annotation_canvas_style_default_1 = require("../../default-values/annotation-canvas-style-default");
var bbox_style_1 = require("./bbox-style");
var paint_style_1 = require("./paint-style");
var AnnotationCanvasStyleFactory = (0, utils_1.IRecord)(annotation_canvas_style_default_1.annotationCanvasStyleDefault);
var IAnnotationCanvasStyle = function (cs) {
    var dfl = AnnotationCanvasStyleFactory();
    var wd = (0, utils_1.withDefaultMix)(cs !== null && cs !== void 0 ? cs : dfl, dfl);
    return AnnotationCanvasStyleFactory({
        root: wd('root'),
        background: wd('background'),
        bgMinPaddingPx: wd('bgMinPaddingPx'),
        bbox: (0, bbox_style_1.IBboxStyle)(wd('bbox')),
        paint: (0, paint_style_1.IPaintStyle)(wd('paint')),
        crosshairLineColor: wd('crosshairLineColor'),
        crosshairLineWidthPx: wd('crosshairLineWidthPx'),
        temporaryRectBorderWidthPx: wd('temporaryRectBorderWidthPx'),
        temporaryRectBorderColor: wd('temporaryRectBorderColor'),
        temporaryRectBackgroundColor: wd('temporaryRectBackgroundColor'),
        labelSaturation: wd('labelSaturation'),
        labelLightness: wd('labelLightness')
    });
};
exports.IAnnotationCanvasStyle = IAnnotationCanvasStyle;
